export const fixPrice = (price: string | number) => {
  const val = Number(String(price).replace(/[^\.\d]/g, ''));
  if (typeof val !== 'number' || isNaN(val) || !isFinite(val) || val <= 0) {
    console.log(typeof val, isNaN(val), isFinite(val), val <= 0);
    console.warn('invalid price', price, val);
    return 0;
  }
  return val;
};
